import { PspRules } from "@CommonTypes/backend/PspRules";

export const RoutePostMerchflow_merchflowId_FlowUpdate = "/merchflow/:merchflowId/flow-update";

export interface PayloadPostMerchflow_merchflowId_FlowUpdate {
  productsToInsert: ProductToInsert[];
  productsToRemove: ProductToRemove[];
  productsToSwap: ProductToSwap[];
  pspRules: PspRules;
}

export interface ResponsePostMerchflow_merchflowId_FlowUpdate {
  storePogTriggerId: number;
}

export interface ProductToRemove {
  productCode: string;
  pnlDecision: PnlDecision;
  storeCodes: string[];
}

export interface ProductToInsert {
  productCode: string;
  adjacentProduct: {
    adjacentProductCode: string;
    placeTo: "LEFT" | "RIGHT";
  } | null;
  facings: "AUTO" | number;
  reducibleProductCode: string | null;
  fitStrategy:
    | "KEEP_ALL_FACINGS"
    | "CAN_REDUCE_FACINGS"
    | "CAN_DELETE_RANGED_PRODUCTS"
    | "CAN_DELETE_RANGED_PRODUCTS_INCLUDING_CORE_RANGE";
  pnlDecision: PnlDecision;
  storeCodes: string[];
  canBeSqueezed: boolean;
}

export interface ProductToSwap {
  productCodeToAdd: string | string[];
  productCodeToRemove: string;
  pnlDecision: PnlDecision;
  storeCodes: string[];
  canSqueezeSwapTo: boolean;
  swapFacingsMode: SwapFacingsMode;
}

export type PnlDecision = "DEFAULT" | "MOVEMENT" | "SALES" | "PROFIT";

export type SwapFacingsMode = "MATCH" | "DOS_MOS_BALANCE";
